export const LOAD_OTHER_CATEGORIES_REQUEST = 'la/domain/categories/LOAD_OTHER_CATEGORIES_REQUEST';
export const LOAD_OTHER_CATEGORIES_SUCCESS = 'la/domain/categories/LOAD_OTHER_CATEGORIES_SUCCESS';
export const LOAD_OTHER_CATEGORIES_FAILURE = 'la/domain/categories/LOAD_OTHER_CATEGORIES_FAILURE';
